import React from "react";

const Footer = () => {
  return (
    <footer className="text-center pb-8 text-color-gray-400 font-Playfair font-medium">
      © 2022 Morgan & Associates. All Rights Reserved
    </footer>
  );
};

export default Footer;
